document.addEventListener("DOMContentLoaded", function () {
	const darkModeToggleButtons = document.querySelectorAll(".swiftpress-toggle");

	if (darkModeToggleButtons.length < 1) return;

	const moon =
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-moon-fill" viewBox="0 0 16 16"> <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278"/></svg>';
	const sun =
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-brightness-high" viewBox="0 0 16 16"><path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8M8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0m0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13m8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5M3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8m10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0m-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0m9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708"/></svg>';

	darkModeToggleButtons.forEach(function (button) {
		// Load saved mode and apply it immediately
		const savedMode = localStorage.getItem("swiftpress-mode") || "light";
		applyMode(savedMode, button);

		// Add click handler
		button.addEventListener("click", function () {
			const currentMode = localStorage.getItem("swiftpress-mode") || "light";
			const newMode = currentMode === "light" ? "dark" : "light";

			// Add animation class to button
			button.classList.add("mode-switching");

			// Add transition class to body
			document.body.classList.add("mode-transitioning");

			localStorage.setItem("swiftpress-mode", newMode);
			applyMode(newMode, button);

			// Remove animation classes after animation completes
			setTimeout(function () {
				button.classList.remove("mode-switching");
			}, 600);

			setTimeout(function () {
				document.body.classList.remove("mode-transitioning");
			}, 400);
		});
	});

	function applyMode(mode, button) {
		const styles = {
			light: {
				bg: button.dataset.lightBg || "#ffffff",
				text: button.dataset.lightText || "#000000",
				link: button.dataset.lightLink || "#0073aa",
				icon: button.dataset.lightIcon || "#000000",
			},
			dark: {
				bg: button.dataset.darkBg || "#111111",
				text: button.dataset.darkText || "#ffffff",
				link: button.dataset.darkLink || "#66ccff",
				icon: button.dataset.darkIcon || "#ffffff",
			},
		};

		const colors = styles[mode];

		// Apply colors
		document.body.style.backgroundColor = colors.bg;
		document.body.style.color = colors.text;

		// Apply CSS custom properties for better cascade control
		document.documentElement.style.setProperty("--bg-color", colors.bg);
		document.documentElement.style.setProperty("--text-color", colors.text);
		document.documentElement.style.setProperty("--link-color", colors.link);

		// Update all links
		document.querySelectorAll("a").forEach(function (link) {
			link.style.color = colors.link;
		});

		// Update button icon and color
		button.innerHTML = mode === "dark" ? sun : moon;
		button.style.color = colors.icon;

		// Toggle dark-mode class
		if (mode === "dark") {
			document.documentElement.classList.add("dark-mode");
		} else {
			document.documentElement.classList.remove("dark-mode");
		}
	}
});
